import { EstCivilType, getFromLocalStorage } from "../../admin/hooks/useUtils";

export default function compareEstcicil(
  id: number | undefined,
  instrucoes: EstCivilType[]
) {
  if (instrucoes?.length == 0) {
    const array = getFromLocalStorage("populateEstCivil");
    instrucoes = array;
  }
  if (!instrucoes) {
    return;
  }
  const itemEncontrado = instrucoes.find(
    (item) => Number(item.estcivil_codigo) === id
  );
  if (itemEncontrado) {
    return itemEncontrado as EstCivilType;
  } else {
    return null;
  }
}
